/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { Link, useParams, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { DatePicker, message, Spin } from "antd";
import Select from "react-select";
import doctorApi from "../../api/doctor.api";
import departmentApi from "../../api/department.api";
import moment from "moment";

const EditDoctor = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  
  // Form state matching backend API structure
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    speciality: '',
    uinNumber: '',
    phone: '',
    email: '',
    notes: '',
    degree: '',
    joiningDate: '',
    departmentId: null
  });
  
  // UI state
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [loadingDepartments, setLoadingDepartments] = useState(true);

  // Bulgarian medical specialties
  const [specialtyOptions] = useState([
    { value: "Вътрешни болести", label: "Вътрешни болести" },
    { value: "Общопрактикуваща медицина", label: "Общопрактикуваща медицина" },
    { value: "Кардиология", label: "Кардиология" },
    { value: "Неврология", label: "Неврология" },
    { value: "Ортопедия", label: "Ортопедия" },
    { value: "Радиология", label: "Радиология" },
    { value: "Стоматология", label: "Стоматология" },
    { value: "Педиатрия", label: "Педиатрия" },
    { value: "Хирургия", label: "Хирургия" },
    { value: "Гинекология", label: "Гинекология" },
    { value: "Дерматология", label: "Дерматология" },
    { value: "Психиатрия", label: "Психиатрия" },
    { value: "Ендокринология", label: "Ендокринология" },
    { value: "Пулмонология", label: "Пулмонология" },
    { value: "Гастроентерология", label: "Гастроентерология" }
  ]);

  // Load doctor data and departments on component mount
  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        
        // Load departments
        const depts = await departmentApi.getAllDepartments(true);
        setDepartments(depts.map(dept => ({
          value: dept.id,
          label: dept.name
        })));
        setLoadingDepartments(false);
        
        // Load doctor data if ID exists
        if (id) {
          const doctor = await doctorApi.getDoctorById(parseInt(id));
          setFormData({
            firstName: doctor.firstName || '',
            lastName: doctor.lastName || '',
            speciality: doctor.speciality || '',
            uinNumber: doctor.uinNumber || '',
            phone: doctor.phone || '',
            email: doctor.email || '',
            notes: doctor.notes || '',
            degree: doctor.degree || '',
            joiningDate: doctor.joiningDate || '',
            departmentId: doctor.department?.id || null
          });
        }
        
      } catch (error) {
        console.error('Error loading data:', error);
        message.error('Грешка при зареждане на данните');
        navigate('/doctors');
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [id, navigate]);

  const onChange = (date, dateString) => {
    setFormData(prev => ({ ...prev, joiningDate: dateString }));
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSpecialityChange = (selectedOption) => {
    setFormData(prev => ({
      ...prev,
      speciality: selectedOption ? selectedOption.value : ''
    }));
  };

  const handleDepartmentChange = (selectedOption) => {
    setFormData(prev => ({
      ...prev,
      departmentId: selectedOption ? selectedOption.value : null
    }));
  };

  const validateForm = () => {
    const required = ['firstName', 'lastName', 'speciality', 'uinNumber', 'phone', 'email'];
    const missing = required.filter(field => !formData[field]);
    
    if (missing.length > 0) {
      message.error(`Моля попълнете задължителните полета: ${missing.join(', ')}`);
      return false;
    }
    
    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      message.error('Моля въведете валиден имейл адрес');
      return false;
    }
    
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    setSaving(true);
    
    try {
      const updateData = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        speciality: formData.speciality,
        uinNumber: formData.uinNumber,
        phone: formData.phone,
        email: formData.email,
        notes: formData.notes || undefined,
        degree: formData.degree || undefined,
        joiningDate: formData.joiningDate || undefined,
        departmentId: formData.departmentId || undefined
      };

      const updatedDoctor = await doctorApi.updateDoctor(parseInt(id), updateData);
      
      message.success(`Лекарят ${updatedDoctor.fullName} беше успешно обновен!`);
      
      setTimeout(() => {
        navigate('/doctors');
      }, 1500);
      
    } catch (error) {
      console.error('Error updating doctor:', error);
      
      if (error.response?.status === 400) {
        message.error('Грешка при валидация на данните. Проверете полетата.');
      } else if (error.response?.data?.message) {
        message.error(error.response.data.message);
      } else {
        message.error('Грешка при обновяване на лекаря. Моля опитайте отново.');
      }
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div>
        <Header />
        <Sidebar id="menu-item1" id1="menu-items1" activeClassName="edit-doctor" />
        <div className="page-wrapper">
          <div className="content" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
            <Spin size="large" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Header />
      <Sidebar
        id="menu-item1"
        id1="menu-items1"
        activeClassName="edit-doctor"
      />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/doctors">Лекари </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">Редактирай лекар</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-heading">
                            <h4>Данни за лекаря</h4>
                          </div>
                        </div>
                        
                        {/* UIN Number */}
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              УИН номер <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="Въведете УИН номер"
                              value={formData.uinNumber}
                              onChange={(e) => handleInputChange('uinNumber', e.target.value)}
                              maxLength="10"
                              required
                            />
                          </div>
                        </div>

                        {/* First Name */}
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              Собствено име <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="Въведете собствено име"
                              value={formData.firstName}
                              onChange={(e) => handleInputChange('firstName', e.target.value)}
                              required
                            />
                          </div>
                        </div>

                        {/* Last Name */}
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              Фамилно име <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="Въведете фамилно име"
                              value={formData.lastName}
                              onChange={(e) => handleInputChange('lastName', e.target.value)}
                              required
                            />
                          </div>
                        </div>

                        {/* Degree */}
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              Образование
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="MBBS, MS, etc."
                              value={formData.degree}
                              onChange={(e) => handleInputChange('degree', e.target.value)}
                            />
                          </div>
                        </div>

                        {/* Speciality */}
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Специалност <span className="login-danger">*</span>
                            </label>
                            <Select
                              value={specialtyOptions.find(opt => opt.value === formData.speciality)}
                              onChange={handleSpecialityChange}
                              options={specialtyOptions}
                              placeholder="Изберете специалност"
                              className="react-select-container"
                              classNamePrefix="react-select"
                              components={{
                                IndicatorSeparator: () => null
                              }}
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused ?'none' : '2px solid rgba(46, 55, 164, 0.1);',
                                   boxShadow: state.isFocused ? '0 0 0 1px #2e37a4' : 'none',
                                  '&:hover': {
                                    borderColor: state.isFocused ? 'none' : '2px solid rgba(46, 55, 164, 0.1)',
                                  },
                                  borderRadius: '10px',
                                  fontSize: "14px",
                                    minHeight: "45px",
                                }),
                              }}
                            />
                          </div>
                        </div>

                        {/* Department */}
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Отделение
                            </label>
                            <Select
                              value={departments.find(dept => dept.value === formData.departmentId)}
                              onChange={handleDepartmentChange}
                              options={departments}
                              placeholder={loadingDepartments ? "Зарежда..." : "Изберете отделение"}
                              isLoading={loadingDepartments}
                              className="react-select-container"
                              classNamePrefix="react-select"
                              components={{
                                IndicatorSeparator: () => null
                              }}
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused ?'none' : '2px solid rgba(46, 55, 164, 0.1);',
                                   boxShadow: state.isFocused ? '0 0 0 1px #2e37a4' : 'none',
                                  '&:hover': {
                                    borderColor: state.isFocused ? 'none' : '2px solid rgba(46, 55, 164, 0.1)',
                                  },
                                  borderRadius: '10px',
                                  fontSize: "14px",
                                    minHeight: "45px",
                                }),
                              }}
                            />
                          </div>
                        </div>

                        {/* Joining Date */}
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms cal-icon">
                            <label>
                              Дата на назначаване
                            </label>
                            <DatePicker
                              className="form-control datetimepicker"
                              onChange={onChange}
                              suffixIcon={null}
                              placeholder="Изберете дата на назначаване"
                              value={formData.joiningDate ? moment(formData.joiningDate) : null}
                            />
                          </div>
                        </div>

                        {/* Phone */}
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Телефон <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="Въведете телефон"
                              value={formData.phone}
                              onChange={(e) => handleInputChange('phone', e.target.value)}
                              required
                            />
                          </div>
                        </div>

                        {/* Email */}
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Имейл <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="email"
                              placeholder="Въведете имейл"
                              value={formData.email}
                              onChange={(e) => handleInputChange('email', e.target.value)}
                              autoComplete="email"
                              required
                            />
                          </div>
                        </div>

                        {/* Notes */}
                        <div className="col-12 col-sm-12">
                          <div className="form-group local-forms">
                            <label>
                              Бележки
                            </label>
                            <textarea
                              className="form-control"
                              rows={3}
                              cols={30}
                              placeholder="Допълнителна информация за лекаря"
                              value={formData.notes}
                              onChange={(e) => handleInputChange('notes', e.target.value)}
                            />
                          </div>
                        </div>

                        {/* Submit Buttons */}
                        <div className="col-12">
                          <div className="doctor-submit d-flex align-items-center flex-column flex-sm-row justify-content-end">
                            <Link
                              to="/doctors"
                              className="btn btn-primary cancel-form d-flex align-items-center justify-content-center mb-2 mb-sm-0 me-sm-2"
                              style={{ 
                                height: '45px', 
                                textAlign: 'center', 
                                textDecoration: 'none',
                                paddingLeft: '15px',
                                paddingRight: '15px',
                                width: '100%',
                                maxWidth: '150px'
                              }}
                            >
                              Отказ
                            </Link>
                            <button
                              type="submit"
                              className="btn btn-primary submit-form"
                              disabled={saving}
                              style={{ 
                                height: '45px',
                                width: '100%',
                                maxWidth: '200px'
                              }}
                            >
                              {saving ? 'Записва...' : 'Запази промените'}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
      
      <style>{`
        .cal-icon::after {
          top: 60% !important;
          transform: translateY(-50%) !important;
        }
      `}</style>
    </div>
  );
};

export default EditDoctor;